import * as React from 'react'
import { Route, SprocketAsset } from '../../../types/types'
import { ArrowIcon } from './LastMinuteSticker'

type Props = {
  kind: 'mobile' | 'desktop'
  route: Route
}

const AwardIcon = (
  <svg
    className="lastminute__clock"
    height="36"
    viewBox="0 0 24 36"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="m24 11.975052c0-6.58627861-5.4-11.975052-12-11.975052s-12 5.38877339-12 11.975052c0 3.8918919 1.8 7.3347193 4.65 9.4303534l-1.65 12.8731809c-.15.5987526.15 1.1975052.6 1.4968815s1.05.2993763 1.65 0l6.75-4.0415801 6.75 4.0415801c.15.1496881.45.1496881.75.1496881s.6-.1496881.75-.2993763c.45-.2993763.75-.8981289.6-1.4968815l-1.65-12.7234927c3-2.0956341 4.8-5.5384615 4.8-9.4303534zm-21 0c0-4.93970896 4.05-8.98128901 9-8.98128901s9 4.04158005 9 8.98128901c0 4.9397089-4.05 8.981289-9 8.981289s-9-4.0415801-9-8.981289zm14.55 19.6091476-4.8-2.8440749c-.45-.2993763-1.05-.2993763-1.5 0l-4.8 2.8440749 1.05-8.5322245c1.35.5987526 2.85.8981289 4.5.8981289s3.15-.2993763 4.5-.8981289z"
      fill="#2a0f4a"
    />
  </svg>
)

export default (props: Props): JSX.Element =>
  props.kind === 'mobile' ? (
    <a className="lastminute__wrap" href={props.route.url}>
      <div className="lastminute">
        {AwardIcon}
        <div>
          <p className="lastminute__text lastminute__text--xl">
            {I18n.t('rental_adverts.corona_policy.view_offers_title')}
          </p>
          <p className="lastminute__text">
            {I18n.t('rental_adverts.corona_policy.view_offers')}
          </p>
        </div>

        {ArrowIcon}
      </div>
    </a>
  ) : (
    <a className="sticker sticker--home-desktop" href={props.route.url}>
      <div className="sticker__inner">
        {AwardIcon}
        <p className={`sticker__title sticker__title--${I18n.locale}`}>
          {I18n.t('rental_adverts.corona_policy.view_offers_title')}
        </p>
        <p className="sticker__label">
          {I18n.t('rental_adverts.corona_policy.view_offers')}
        </p>
        <span className="sticker__arrow icon-arrow-right" />
      </div>
    </a>
  )
